export default "__VITE_ASSET__DlWE1XZp__"